/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  forwardRef,
} from 'react';
import type {
  ComponentPropsWithRef,
  ComponentType,
  ForwardedRef,
  Ref,
  MouseEventHandler,
  PropsWithChildren,
  ReactElement,
} from 'react';

import styled from 'styled-components';

export const StyledFakeLink = styled.span<{
  disabled?: boolean;
}>(({
  disabled,

  theme: {
    colors,
  },
}) => ({
  font: 'inherit',
  display: 'inline',
  textDecoration: 'none',
  color: colors.ACTION_DEFAULT,
  border: 'none',
  padding: 0,
  margin: 0,
  cursor: disabled ? 'default' : 'pointer',
  backgroundColor: 'transparent',
  outline: 'none',
  textAlign: 'inherit',

  ':hover': {
    color: colors.ACTION_HOVER,
  },

  ':active': {
    color: colors.ACTION_PRESSED,
  },
}));

export type FakeLinkComponentProps = {
  disabled: boolean;
  onClick?: MouseEventHandler;
  ref: Ref<HTMLElement>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
};

export type FakeLinkAdditionalProps<
FakeLinkComponent extends keyof JSX.IntrinsicElements | ComponentType<any>,
> = PropsWithChildren<{
  component?: FakeLinkComponent;
  /**
   * Выключена ли обработка событий
   */
  disabled?: boolean;
  /**
   * Обработчик нажатия, вызывается, если disabled не true
   */
  onClick?: MouseEventHandler;
}>;

export type FakeLinkProps<
FakeLinkComponent extends keyof JSX.IntrinsicElements | ComponentType<any>,
> =
    & Omit<
    ComponentPropsWithRef<FakeLinkComponent>,
    keyof FakeLinkAdditionalProps<FakeLinkComponent>
    >
    & FakeLinkAdditionalProps<FakeLinkComponent>;

function FakeLinkInner<
RefElementType,
FakeLinkComponent extends keyof JSX.IntrinsicElements | ComponentType<any> = 'span',
>(
  {
    children = undefined,
    component: RootComponent = ('span' as FakeLinkComponent),
    disabled = false,
    onClick = undefined,
    ...rest
  }: FakeLinkProps<FakeLinkComponent>,
  ref: ForwardedRef<RefElementType>,
): ReactElement {
  const componentProps = {
    ...rest,
    disabled,
    onClick: disabled ? undefined : onClick,
    ref,
  } as ComponentPropsWithRef<FakeLinkComponent>;

  return (
    <StyledFakeLink
      as={RootComponent}
      {...componentProps}
    >
      {children}
    </StyledFakeLink>
  );
}

export const FakeLink = forwardRef(FakeLinkInner);
